(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('yield-curve-results', {
            parent: 'entity',
            url: '/yield-curve-results',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.yieldCurveResults.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/yield-curve-results/yield-curve-results.html',
                    controller: 'YieldCurveResultsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('yieldCurveResults');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('yield-curve-results-detail', {
            parent: 'yield-curve-results',
            url: '/yield-curve-results/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'moldovaYieldCurvesApp.yieldCurveResults.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/yield-curve-results/yield-curve-results-detail.html',
                    controller: 'YieldCurveResultsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('yieldCurveResults');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'YieldCurveResults', function($stateParams, YieldCurveResults) {
                    return YieldCurveResults.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'yield-curve-results',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('yield-curve-results-detail.edit', {
            parent: 'yield-curve-results-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/yield-curve-results/yield-curve-results-dialog.html',
                    controller: 'YieldCurveResultsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['YieldCurveResults', function(YieldCurveResults) {
                            return YieldCurveResults.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('yield-curve-results.new', {
            parent: 'yield-curve-results',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/yield-curve-results/yield-curve-results-dialog.html',
                    controller: 'YieldCurveResultsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                m: null,
                                codeRevisionDate: null,
                                codeRevisionNumber: null,
                                date: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('yield-curve-results', null, { reload: 'yield-curve-results' });
                }, function() {
                    $state.go('yield-curve-results');
                });
            }]
        })
        .state('yield-curve-results.edit', {
            parent: 'yield-curve-results',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/yield-curve-results/yield-curve-results-dialog.html',
                    controller: 'YieldCurveResultsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['YieldCurveResults', function(YieldCurveResults) {
                            return YieldCurveResults.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('yield-curve-results', null, { reload: 'yield-curve-results' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('yield-curve-results.delete', {
            parent: 'yield-curve-results',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/yield-curve-results/yield-curve-results-delete-dialog.html',
                    controller: 'YieldCurveResultsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['YieldCurveResults', function(YieldCurveResults) {
                            return YieldCurveResults.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('yield-curve-results', null, { reload: 'yield-curve-results' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
